// extracted by mini-css-extract-plugin
module.exports = {"root":"ClearentDisclaimer_root__2lWho","header":"ClearentDisclaimer_header__R3q5W","inner":"ClearentDisclaimer_inner__3SqiH"};